import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import CrudClientWarehouse from "../../organisms/Client/CrudClientWarehouse.tsx";
import { useCompany } from "../../contexts/CompanyContext";
import { Box, Typography } from "@mui/material";

export default function ClientWarehouseScreen(): JSX.Element {
  const { selectedCompany } = useCompany();
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [selectedCompany]);

  if (!selectedCompany) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Seleccione una compañía primero</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <CrudClientWarehouse key={key} />
    </DashboardLayout>
  );
}
